export default __webpack_public_path__ + "static/media/7.46f16940.jpg";